// utils/constants.js
export const INTRO = "https://ik.imagekit.io/cloy701fl/images/pfi-video/loader.mp4";
